const getLayerDirectory = (layer) => {
  if (layer === 'Background') return 'backgrounds';
  if (layer === 'Eyes') return 'eyes';
  if (layer === 'Mouth') return 'mouthes';
  if (layer === 'Clothing') return 'clothing';
  if (layer === 'Fur') return 'furs';
  if (layer === 'Head') return 'heads';
  if (layer === 'Accessory') return 'accessories';
  if (layer === 'Whiskers') return 'whiskers';
};

export const getTraitImagePath = (layer, value, properties) => {
  if (!layer || !value) return '';
  // special case for space helmet + whiskers
  if (properties) {
    if (layer === 'Fur' && value === 'Normal' && properties['Head'] === 'Robot Hand') {
      return `/fourth-litter/traits/fur/Normal - Robot Hand.png`;
    }
    if (layer === 'Whiskers' && properties['Head'] === 'Space Helmet') {
      return `/fourth-litter/traits/whiskers/Normal - Space Helmet.png`;
    }
    if (layer === 'Whiskers' && properties['Clothing'] === 'Baja Hoodie') {
      return `/fourth-litter/traits/whiskers/Normal - Baja Hoodie.png`;
    }
    if (layer === 'Whiskers' && properties['Head'] === 'Carved Pumpkin') {
      return `/fourth-litter/traits/whiskers/Normal - Carved Pumpkin.png`;
    }
    if (layer === 'Whiskers' && properties['Head'] === 'Wrapped Flower') {
      return `/fourth-litter/traits/whiskers/Normal - Wrapped Flower.png`;
    }
    if (layer === 'Whiskers' && ['Fish Bowl - Normal', 'Fish Bowl - Skeleton', 'Fish Bowl'].includes(properties['Head'])) {
      return `/fourth-litter/traits/whiskers/Normal - Fish Bowl.png`;
    }
    if (layer === 'Clothing' && value === 'Muscle Suit' && properties['Fur'] === 'Devil') {
      return `/fourth-litter/traits/clothing/Muscle Suit - Devil.png`;
    }
    if (layer === 'Clothing' && value === 'Muscle Suit' && properties['Fur'] === 'Hairless') {
      return `/fourth-litter/traits/clothing/Muscle Suit - Hairless.png`;
    }
  }
  return `/fourth-litter/traits/${getLayerDirectory(layer)}/${value.replace('#', '')}.png`;
};
